import { ReactNode } from 'react';
import styled, { css } from 'styled-components';

import { typeButtonStyle } from 'coreOld/components/Button';

type SelectButtonProps = {
  type?: keyof typeof typeButtonStyle;
  disabled?: boolean;
  children?: ReactNode;
};

const SelectButton = styled.a<SelectButtonProps>`
  min-width: 241px;
  text-transform: uppercase;
  text-align: center;
  padding: 17px 16px 16px;

  font:
    400 13px 'Arial',
    sans-serif;
  flex: 1 1 auto;
  border-radius: 5px;
  justify-content: center;
  flex-wrap: wrap;
  display: flex;
  align-items: center;
  cursor: pointer;
  border: 1px solid #797979;
  background-color: ${({ theme }) => theme.palette.backgrounds.main};
  color: ${({ theme }) => theme.palette.text.button};

  &:hover {
    background-color: ${({ theme }) => theme.palette.backgrounds.button};
    color: ${({ theme }) => theme.palette.text.secondary};
  }

  :not(:first-child) {
    margin-top: 10px;
  }

  ${({ type }) =>
    type &&
    css`
      ${typeButtonStyle[type]}
    `}

  ${({ disabled }) =>
    disabled &&
    css`
      opacity: 0.5;
      pointer-events: none;
    `}
`;

export default SelectButton;
